module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/react-dom/~/prop-types/lib/has.js
// module id = 1902
// module chunks = 0